const STRINGS: Record<string, Record<string, string>> = {
  es: {
    "select.title": "Selecciona un workspace",
    "select.subtitle": "Cada workspace tiene sus propias campañas, plantillas, segmentos y reportes.",
    "select.create": "Crear workspace",
    "invitations.title": "Invitaciones pendientes",
    "invitations.subtitle": "Te invitaron a estos workspaces. Acepta para entrar con los permisos que te asignaron.",
    "invitations.accept": "Aceptar invitación",
    "invitations.errors.accept_failed": "No se pudo aceptar la invitación. Puede haber expirado o haber sido cancelada.",
    "create.title": "Crear workspace",
    "create.first_title": "Crea tu primer workspace",
    "create.subtitle": "Ponle un nombre y elige el plan con el que vas a arrancar. Puedes cambiar el plan después.",
    "create.subtitle_no_plans": "Ponle un nombre para empezar.",
    "create.submit": "Crear workspace",
    "fields.name": "Nombre del workspace",
    "fields.name_placeholder": "Ej. Marketing Mi Evento Perfecto",
    "fields.plan": "Plan",
    "fields.plan_hint": "El plan define cuántos correos y contactos puedes usar.",
    "switcher.title": "Workspaces",
    "switcher.create": "Crear workspace",
    "back_to_list": "Volver a mis workspaces",
    "actions.cancel": "Cancelar",
    "actions.save": "Guardar",
    "actions.edit": "Editar",
    "actions.remove": "Quitar",
    "loading": "Cargando...",
    "errors.name_required": "El nombre del workspace es obligatorio",
    "errors.name_too_long": "El nombre no puede exceder 255 caracteres",
    "errors.create_failed": "No se pudo crear el workspace. Intenta de nuevo.",
    "errors.load_failed": "No se pudieron cargar tus workspaces.",
    "plans.recommended": "Recomendado",
    "plans.FREE.label": "Gratuito",
    "plans.FREE.description": "Para empezar a probar el marketing de tus eventos.",
    "plans.FREE.price": "$0",
    "plans.FREE.emails": "Envíos de correo limitados",
    "plans.FREE.contacts": "Base de contactos básica",
    "plans.FREE.support": "Soporte por comunidad",
    "plans.BASIC.label": "Básico",
    "plans.BASIC.description": "Para promotores con campañas recurrentes.",
    "plans.BASIC.price": "Por definir",
    "plans.BASIC.emails": "Más envíos de correo al mes",
    "plans.BASIC.contacts": "Segmentos y contactos ampliados",
    "plans.BASIC.support": "Soporte por correo",
    "plans.PREMIUM.label": "Premium",
    "plans.PREMIUM.description": "Para operaciones de marketing a gran escala.",
    "plans.PREMIUM.price": "Por definir",
    "plans.PREMIUM.emails": "Envíos de correo de alto volumen",
    "plans.PREMIUM.contacts": "Contactos y segmentos sin límite práctico",
    "plans.PREMIUM.support": "Soporte prioritario",
    "members.title": "Usuarios del workspace",
    "members.subtitle": "Administra quién entra a {{workspace}}, con qué rol y a qué secciones tiene acceso.",
    "members.add": "Agregar usuario",
    "members.add_denied": "Solo el dueño y los administradores del workspace pueden agregar usuarios.",
    "members.add_title": "Agregar usuario al workspace",
    "members.edit_title": "Editar acceso del usuario",
    "members.no_workspace": "Selecciona un workspace para administrar sus usuarios.",
    "members.all_screens": "Todas las pantallas",
    "members.no_screens": "Sin pantallas asignadas",
    "members.no_candidates": "No se encontraron usuarios con ese correo",
    "members.already_member": "Ya es miembro",
    "members.confirm_remove": "{{email}} pierde el acceso a este workspace de inmediato.",
    "members.confirm_revoke": "La invitación de {{email}} deja de servir para entrar a este workspace.",
    "members.invite_this_email": "Invitar a {{email}}",
    "members.invite_title": "Invitar usuario al workspace",
    "members.invite_send": "Enviar invitación",
    "members.cancel_invitation": "Cancelar invitación",
    "members.resend_invitation": "Reenviar",
    "members.status.active": "Activo",
    "members.status.pending": "Pendiente",
    "members.status.expired": "Expirada",
    "members.errors.invite_failed": "No se pudo enviar la invitación. Intenta de nuevo.",
    "members.errors.resend_failed": "No se pudo reenviar la invitación. Intenta de nuevo.",
    "members.columns.user": "Usuario",
    "members.columns.role": "Rol",
    "members.columns.screens": "Pantallas",
    "members.columns.permissions": "Permisos",
    "members.columns.status": "Estado",
    "members.columns.since": "Alta",
    "members.columns.last_activity": "Última actividad",
    "members.my_access_title": "Mis permisos",
    "members.my_access_subtitle": "Consulta tu rol y las secciones a las que tienes acceso en este workspace.",
    "members.access_title": "Permisos del usuario",
    "members.access_subtitle": "El rol de esta persona y las secciones a las que tiene acceso en este workspace.",
    "members.access_role": "Rol: {{role}}",
    "members.access_counter": "{{count}} de {{total}} permisos habilitados",
    "members.matrix_open": "Ver los permisos",
    "members.remove_title": "Quitar usuario",
    "members.remove_confirm": "Quitar usuario",
    "members.revoke_title": "Cancelar invitación",
    "members.revoke_confirm": "Cancelar invitación",
    "members.errors.remove_failed": "No se pudo quitar al usuario. Intenta de nuevo.",
    "members.errors.revoke_failed": "No se pudo cancelar la invitación. Intenta de nuevo.",
    "actions.back": "Volver",
    "members.fields.permissions": "Permisos por pantalla",
    "members.all_permissions": "Todos los permisos",
    "members.permissions_count": "{{count}} permisos",
    "members.permissions_count_one": "1 permiso",
    "members.status.invited": "Invitado",
    "members.empty": "Todavía no hay usuarios en este workspace.",
    "members.fields.email": "Correo",
    "members.fields.email_placeholder": "nombre@empresa.com",
    "members.fields.role": "Rol",
    "members.fields.screens": "Pantallas que puede ver",
    "members.roles.OWNER": "Dueño",
    "members.roles.ADMIN": "Administrador",
    "members.roles.MEMBER": "Miembro",
    "members.roles.ADMIN_hint": "Acceso completo al workspace, incluida la administración de usuarios.",
    "members.roles.MEMBER_hint": "Solo las pantallas que le marques abajo.",
    "members.errors.pick_user": "Selecciona un usuario de la lista",
    "members.errors.invalid_email": "Ingresa un correo válido",
    "members.existing_account_hint": "Ya tiene cuenta en Ticketón — se le enviará un correo para iniciar sesión y aceptar la invitación.",
    "members.new_account_hint": "No tiene cuenta todavía — se le enviará un correo para registrarse y aceptar la invitación.",
    "members.errors.save_failed": "No se pudo guardar el acceso. Intenta de nuevo.",
    "members.errors.load_failed": "No se pudieron cargar los usuarios del workspace.",
    "members.marketing_group_label": "Pantallas de Marketing",
    "members.select_all": "Seleccionar todas",
    "members.selected_counter": "{{count}} de {{total}} seleccionados",
    "members.admin_all_screens": "Un administrador entra a todas las pantallas y puede administrar usuarios del workspace.",
    "members.no_screens_warning": "Sin pantallas marcadas no va a poder entrar a nada.",
    "members.errors.pick_a_screen": "Selecciona al menos una pantalla para guardar.",
    "screens.dashboard": "Dashboard",
    "screens.reports": "Reportes",
    "screens.crm": "CRM",
    "screens.agents": "Agentes IA",
    "screens.assistant": "Asistente IA",
    "screens.integrations": "Integraciones",
    "screens.campaigns": "Marketing (todo)",
    "screens.settings": "Configuración",
    "screens.marketing_campaigns_dashboard": "Dashboard de campañas",
    "screens.marketing_campaigns_calendar": "Calendario de campañas",
    "screens.marketing_event_campaigns": "Campañas de eventos",
    "screens.marketing_task_assignments": "Asignación de tareas",
    "screens.marketing_short_links": "Enlaces cortos",
    "screens.marketing_landing_pages": "Landing pages",
    "screens.marketing_userbase_stats": "Estadísticas de usuarios",
    "screens.marketing_sms_campaigns": "Campañas SMS",
    "screens.marketing_email_campaigns": "Campañas de email",
    "screens.marketing_email_templates": "Plantillas de email",
    "screens.marketing_segments": "Segmentos",
    "screens.marketing_ads": "Anuncios",
    "screens.assets": "Biblioteca de imágenes",
    "assets.title": "Biblioteca de imágenes",
    "assets.subtitle": "Imágenes de {{workspace}}. Súbelas una vez y úsalas en landing pages, correos y campañas; se comprimen y convierten a WebP automáticamente.",
    "assets.count": "{{count}} imágenes",
    "assets.search_placeholder": "Buscar por nombre o texto alternativo",
    "assets.upload_hint": "Arrastra imágenes o carpetas aquí, o haz clic para elegir varias",
    "assets.upload_formats": "JPG, PNG, WebP, GIF o SVG · hasta {{max}} MB por archivo",
    "assets.uploads_title": "Subidas",
    "assets.uploads_clear": "Limpiar terminadas",
    "assets.uploads_progress": "Subiendo {{done}} de {{total}}…",
    "assets.uploads_finished": "{{done}} de {{total}} subidas",
    "assets.uploads_failed": "{{count}} con error",
    "assets.uploads_retry_failed": "Reintentar fallidas",
    "assets.uploads_cancel_pending": "Cancelar pendientes",
    "assets.empty": "Aún no hay imágenes en este workspace. Sube la primera arrastrándola arriba.",
    "assets.empty_search": "No hay imágenes que coincidan con \"{{search}}\".",
    "assets.errors.load_failed": "No se pudieron cargar las imágenes.",
    "assets.errors.upload_failed": "No se pudo subir {{file}}.",
    "assets.errors.unsupported_format": "{{file}}: formato no admitido.",
    "assets.errors.file_too_big": "{{file}}: excede el tamaño máximo.",
    "assets.errors.save_failed": "No se pudieron guardar los cambios.",
    "assets.errors.delete_failed": "No se pudo eliminar la imagen.",
    "assets.errors.copy_failed": "No se pudo copiar la URL.",
    "assets.errors.name_required": "El nombre es obligatorio.",
    "assets.details.title": "Detalles de la imagen",
    "assets.details.name": "Nombre",
    "assets.details.alt": "Texto alternativo",
    "assets.details.alt_hint": "Describe la imagen para lectores de pantalla y SEO",
    "assets.details.url": "URL en el CDN",
    "assets.details.copy": "Copiar URL",
    "assets.details.open": "Abrir en una pestaña nueva",
    "assets.details.fallback": "Copia JPG para clientes sin WebP",
    "assets.details.original_size": "Archivo original: {{size}}",
    "assets.details.uploaded": "subida el {{date}}",
    "assets.details.delete": "Eliminar",
    "assets.details.delete_title": "¿Eliminar esta imagen?",
    "assets.details.delete_description": "\"{{name}}\" dejará de aparecer en la biblioteca. Las páginas que ya la usan seguirán mostrándola.",
    "assets.picker.title": "Elegir de la biblioteca",
    "assets.picker.subtitle": "Imágenes de {{workspace}}. Haz doble clic para usar una, o súbela aquí mismo.",
    "assets.picker.select": "Usar imagen",
    "assets.picker.no_workspace": "Selecciona un workspace para ver sus imágenes.",
    "assets.picker.all_folders": "Buscar en todas las carpetas",
    "assets.folders.title": "Carpetas",
    "assets.folders.root": "Todas las imágenes",
    "assets.folders.new": "Nueva carpeta",
    "assets.folders.new_subfolder": "Nueva subcarpeta",
    "assets.folders.rename": "Renombrar o mover",
    "assets.folders.delete": "Eliminar carpeta",
    "assets.folders.actions": "Acciones de la carpeta",
    "assets.folders.expand": "Expandir",
    "assets.folders.collapse": "Contraer",
    "assets.folders.empty": "Crea carpetas para agrupar tus imágenes.",
    "assets.folders.create_title": "Nueva carpeta",
    "assets.folders.edit_title": "Editar carpeta",
    "assets.folders.inside": "Dentro de {{path}}",
    "assets.folders.at_root": "En el nivel principal",
    "assets.folders.name": "Nombre",
    "assets.folders.name_placeholder": "Ej. Banners verano 2026",
    "assets.folders.parent": "Carpeta superior",
    "assets.folders.no_parent": "Nivel principal (sin carpeta superior)",
    "assets.folders.create": "Crear carpeta",
    "assets.folders.delete_title": "¿Eliminar la carpeta \"{{name}}\"?",
    "assets.folders.delete_description": "Se eliminan la carpeta y sus subcarpetas. Las imágenes que contienen no se borran: pasan a \"Todas las imágenes\".",
    "assets.folders.move_to": "Carpeta",
    "assets.folders.upload_target": "Las imágenes nuevas se guardan en: {{path}}",
    "assets.folders.errors.name_required": "El nombre de la carpeta es obligatorio.",
    "assets.folders.errors.create_failed": "No se pudo crear la carpeta.",
    "assets.folders.errors.save_failed": "No se pudo guardar la carpeta.",
    "assets.folders.errors.delete_failed": "No se pudo eliminar la carpeta.",
    "assets.folders.errors.load_failed": "No se pudieron cargar las carpetas.",
    "assets.empty_folder": "Esta carpeta está vacía. Arrastra imágenes arriba para guardarlas aquí.",
  },
  en: {
    "select.title": "Select a workspace",
    "select.subtitle": "Each workspace has its own campaigns, templates, segments and reports.",
    "select.create": "Create workspace",
    "invitations.title": "Pending invitations",
    "invitations.subtitle": "You have been invited to these workspaces. Accept to get in with the access you were given.",
    "invitations.accept": "Accept invitation",
    "invitations.errors.accept_failed": "The invitation could not be accepted. It may have expired or been cancelled.",
    "create.title": "Create workspace",
    "create.first_title": "Create your first workspace",
    "create.subtitle": "Give it a name and pick the plan you want to start with. You can change the plan later.",
    "create.subtitle_no_plans": "Give it a name to get started.",
    "create.submit": "Create workspace",
    "fields.name": "Workspace name",
    "fields.name_placeholder": "e.g. Marketing My Perfect Event",
    "fields.plan": "Plan",
    "fields.plan_hint": "The plan defines how many emails and contacts you can use.",
    "switcher.title": "Workspaces",
    "switcher.create": "Create workspace",
    "back_to_list": "Back to my workspaces",
    "actions.cancel": "Cancel",
    "actions.save": "Save",
    "actions.edit": "Edit",
    "actions.remove": "Remove",
    "loading": "Loading...",
    "errors.name_required": "Workspace name is required",
    "errors.name_too_long": "The name cannot exceed 255 characters",
    "errors.create_failed": "The workspace could not be created. Please try again.",
    "errors.load_failed": "Your workspaces could not be loaded.",
    "plans.recommended": "Recommended",
    "plans.FREE.label": "Free",
    "plans.FREE.description": "To start testing marketing for your events.",
    "plans.FREE.price": "$0",
    "plans.FREE.emails": "Limited email sends",
    "plans.FREE.contacts": "Basic contact base",
    "plans.FREE.support": "Community support",
    "plans.BASIC.label": "Basic",
    "plans.BASIC.description": "For promoters running recurring campaigns.",
    "plans.BASIC.price": "TBD",
    "plans.BASIC.emails": "More email sends per month",
    "plans.BASIC.contacts": "Expanded segments and contacts",
    "plans.BASIC.support": "Email support",
    "plans.PREMIUM.label": "Premium",
    "plans.PREMIUM.description": "For large-scale marketing operations.",
    "plans.PREMIUM.price": "TBD",
    "plans.PREMIUM.emails": "High-volume email sends",
    "plans.PREMIUM.contacts": "Practically unlimited contacts and segments",
    "plans.PREMIUM.support": "Priority support",
    "members.title": "Workspace users",
    "members.subtitle": "Manage who gets into {{workspace}}, with which role, and which sections they can reach.",
    "members.add": "Add user",
    "members.add_denied": "Only the workspace owner and its admins can add users.",
    "members.add_title": "Add user to workspace",
    "members.edit_title": "Edit user access",
    "members.no_workspace": "Pick a workspace to manage its users.",
    "members.all_screens": "All screens",
    "members.no_screens": "No screens assigned",
    "members.no_candidates": "No users found with that email",
    "members.already_member": "Already a member",
    "members.confirm_remove": "{{email}} loses access to this workspace right away.",
    "members.confirm_revoke": "The invitation for {{email}} will no longer let them into this workspace.",
    "members.invite_this_email": "Invite {{email}}",
    "members.invite_title": "Invite user to workspace",
    "members.invite_send": "Send invitation",
    "members.cancel_invitation": "Cancel invitation",
    "members.resend_invitation": "Resend",
    "members.status.active": "Active",
    "members.status.pending": "Pending",
    "members.status.expired": "Expired",
    "members.errors.invite_failed": "The invitation could not be sent. Please try again.",
    "members.errors.resend_failed": "The invitation could not be resent. Please try again.",
    "members.columns.user": "User",
    "members.columns.role": "Role",
    "members.columns.screens": "Screens",
    "members.columns.permissions": "Permissions",
    "members.columns.status": "Status",
    "members.columns.since": "Added",
    "members.columns.last_activity": "Last activity",
    "members.my_access_title": "My permissions",
    "members.my_access_subtitle": "Your role and the sections you can reach in this workspace.",
    "members.access_title": "User permissions",
    "members.access_subtitle": "This person's role and the sections they can reach in this workspace.",
    "members.access_role": "Role: {{role}}",
    "members.access_counter": "{{count}} of {{total}} permissions enabled",
    "members.matrix_open": "See permissions",
    "members.remove_title": "Remove user",
    "members.remove_confirm": "Remove user",
    "members.revoke_title": "Cancel invitation",
    "members.revoke_confirm": "Cancel invitation",
    "members.errors.remove_failed": "The user could not be removed. Try again.",
    "members.errors.revoke_failed": "The invitation could not be cancelled. Try again.",
    "actions.back": "Back",
    "members.fields.permissions": "Permissions by screen",
    "members.all_permissions": "All permissions",
    "members.permissions_count": "{{count}} permissions",
    "members.permissions_count_one": "1 permission",
    "members.status.invited": "Invited",
    "members.empty": "There are no users in this workspace yet.",
    "members.fields.email": "Email",
    "members.fields.email_placeholder": "name@company.com",
    "members.fields.role": "Role",
    "members.fields.screens": "Screens they can see",
    "members.roles.OWNER": "Owner",
    "members.roles.ADMIN": "Administrator",
    "members.roles.MEMBER": "Member",
    "members.roles.ADMIN_hint": "Full access to the workspace, including user administration.",
    "members.roles.MEMBER_hint": "Only the screens you tick below.",
    "members.errors.pick_user": "Pick a user from the list",
    "members.errors.invalid_email": "Enter a valid email",
    "members.existing_account_hint": "Already has a Ticketón account — they'll get an email to log in and accept the invitation.",
    "members.new_account_hint": "No account yet — they'll get an email to register and accept the invitation.",
    "members.errors.save_failed": "The access could not be saved. Please try again.",
    "members.errors.load_failed": "The workspace users could not be loaded.",
    "members.marketing_group_label": "Marketing screens",
    "members.select_all": "Select all",
    "members.selected_counter": "{{count}} of {{total}} selected",
    "members.admin_all_screens": "An admin reaches every screen and can manage the workspace's users.",
    "members.no_screens_warning": "With no screens ticked they will not be able to open anything.",
    "members.errors.pick_a_screen": "Pick at least one screen to save.",
    "screens.dashboard": "Dashboard",
    "screens.reports": "Reports",
    "screens.crm": "CRM",
    "screens.agents": "AI Agents",
    "screens.assistant": "AI Assistant",
    "screens.integrations": "Integrations",
    "screens.campaigns": "Marketing (all)",
    "screens.settings": "Settings",
    "screens.marketing_campaigns_dashboard": "Campaigns dashboard",
    "screens.marketing_campaigns_calendar": "Campaigns calendar",
    "screens.marketing_event_campaigns": "Event campaigns",
    "screens.marketing_task_assignments": "Task assignments",
    "screens.marketing_short_links": "Short links",
    "screens.marketing_landing_pages": "Landing pages",
    "screens.marketing_userbase_stats": "Userbase stats",
    "screens.marketing_sms_campaigns": "SMS campaigns",
    "screens.marketing_email_campaigns": "Email campaigns",
    "screens.marketing_email_templates": "Email templates",
    "screens.marketing_segments": "Segments",
    "screens.marketing_ads": "Ads",
    "screens.assets": "Image library",
    "assets.title": "Image library",
    "assets.subtitle": "Images of {{workspace}}. Upload once and reuse them on landing pages, emails and campaigns; they are compressed and converted to WebP automatically.",
    "assets.count": "{{count}} images",
    "assets.search_placeholder": "Search by name or alt text",
    "assets.upload_hint": "Drag images or folders here, or click to pick several",
    "assets.upload_formats": "JPG, PNG, WebP, GIF or SVG · up to {{max}} MB per file",
    "assets.uploads_title": "Uploads",
    "assets.uploads_clear": "Clear finished",
    "assets.uploads_progress": "Uploading {{done}} of {{total}}…",
    "assets.uploads_finished": "{{done}} of {{total}} uploaded",
    "assets.uploads_failed": "{{count}} failed",
    "assets.uploads_retry_failed": "Retry failed",
    "assets.uploads_cancel_pending": "Cancel pending",
    "assets.empty": "No images in this workspace yet. Drop the first one above.",
    "assets.empty_search": "No images match \"{{search}}\".",
    "assets.errors.load_failed": "The images could not be loaded.",
    "assets.errors.upload_failed": "{{file}} could not be uploaded.",
    "assets.errors.unsupported_format": "{{file}}: unsupported format.",
    "assets.errors.file_too_big": "{{file}}: exceeds the maximum size.",
    "assets.errors.save_failed": "The changes could not be saved.",
    "assets.errors.delete_failed": "The image could not be deleted.",
    "assets.errors.copy_failed": "The URL could not be copied.",
    "assets.errors.name_required": "The name is required.",
    "assets.details.title": "Image details",
    "assets.details.name": "Name",
    "assets.details.alt": "Alt text",
    "assets.details.alt_hint": "Describe the image for screen readers and SEO",
    "assets.details.url": "CDN URL",
    "assets.details.copy": "Copy URL",
    "assets.details.open": "Open in a new tab",
    "assets.details.fallback": "JPG copy for clients without WebP",
    "assets.details.original_size": "Original file: {{size}}",
    "assets.details.uploaded": "uploaded on {{date}}",
    "assets.details.delete": "Delete",
    "assets.details.delete_title": "Delete this image?",
    "assets.details.delete_description": "\"{{name}}\" will disappear from the library. Pages already using it keep showing it.",
    "assets.picker.title": "Choose from library",
    "assets.picker.subtitle": "Images of {{workspace}}. Double-click to use one, or upload right here.",
    "assets.picker.select": "Use image",
    "assets.picker.no_workspace": "Select a workspace to see its images.",
    "assets.picker.all_folders": "Search every folder",
    "assets.folders.title": "Folders",
    "assets.folders.root": "All images",
    "assets.folders.new": "New folder",
    "assets.folders.new_subfolder": "New subfolder",
    "assets.folders.rename": "Rename or move",
    "assets.folders.delete": "Delete folder",
    "assets.folders.actions": "Folder actions",
    "assets.folders.expand": "Expand",
    "assets.folders.collapse": "Collapse",
    "assets.folders.empty": "Create folders to group your images.",
    "assets.folders.create_title": "New folder",
    "assets.folders.edit_title": "Edit folder",
    "assets.folders.inside": "Inside {{path}}",
    "assets.folders.at_root": "At the top level",
    "assets.folders.name": "Name",
    "assets.folders.name_placeholder": "e.g. Summer 2026 banners",
    "assets.folders.parent": "Parent folder",
    "assets.folders.no_parent": "Top level (no parent)",
    "assets.folders.create": "Create folder",
    "assets.folders.delete_title": "Delete folder \"{{name}}\"?",
    "assets.folders.delete_description": "The folder and its subfolders are removed. The images inside are not deleted: they move to \"All images\".",
    "assets.folders.move_to": "Folder",
    "assets.folders.upload_target": "New images are saved in: {{path}}",
    "assets.folders.errors.name_required": "The folder name is required.",
    "assets.folders.errors.create_failed": "The folder could not be created.",
    "assets.folders.errors.save_failed": "The folder could not be saved.",
    "assets.folders.errors.delete_failed": "The folder could not be deleted.",
    "assets.folders.errors.load_failed": "The folders could not be loaded.",
    "assets.empty_folder": "This folder is empty. Drop images above to store them here.",
  },
};

export type WorkspaceTranslate = (key: string, params?: Record<string, string>) => string;

export function createTranslate(locale: string): WorkspaceTranslate {
  const language = locale?.substring(0, 2) === "en" ? "en" : "es";
  const dictionary = STRINGS[language] ?? {};
  const fallbackDictionary = STRINGS.es ?? {};

  return (key, params) => {
    const value = dictionary[key] ?? fallbackDictionary[key] ?? key;

    if (!params) return value;

    return Object.entries(params).reduce(
      (text, [name, replacement]) => text.replace(`{{${name}}}`, replacement),
      value
    );
  };
}
